// NOTE: Chart.js上では、16進数カラーコードが使えないため、RGBに変換する
export const colorCodeToRGBA = (code: string, alpha: number) => {
  const red = parseInt(code.substring(1, 3), 16);
  const green = parseInt(code.substring(3, 5), 16);
  const blue = parseInt(code.substring(5, 7), 16);
  const rgba = [red, green, blue, alpha].join(",");

  return `rgba(${rgba})`;
};

export const appHeaderHeight = "56px";

export const grayscale10 = "#FFFFFF";
export const grayscale90 = "#232323";
export const grayscale60 = "#909090";
export const grayscale6002 = colorCodeToRGBA(grayscale60, 0.2);
export const line10 = "#EEF2F6";

export const grayscale40 = "#CFCFCF";
export const grayscale4004 = colorCodeToRGBA(grayscale40, 0.4);
export const grayscale70 = "#6F6F6F";
export const grayscale7002 = colorCodeToRGBA(grayscale70, 0.2);
export const primaryBlueDefault = "#2D75F5";
export const primaryBlueDefault02 = colorCodeToRGBA(primaryBlueDefault, 0.2);
export const primaryBlueDefault04 = colorCodeToRGBA(primaryBlueDefault, 0.4);

export const chartBlue = colorCodeToRGBA("#53A1FF", 1);
export const chartBlueLight = colorCodeToRGBA("#BCD8FA", 1);
export const chartBlueDeep = colorCodeToRGBA("#2D75F5", 1);
export const chartGray01 = colorCodeToRGBA("#909090", 1);
export const chartGray02 = colorCodeToRGBA("#EDEEEF", 1);
export const chartTransparent = colorCodeToRGBA("#53A1FF", 0);
export const chartBlueLevel01 = colorCodeToRGBA("#69ADFF", 1);
export const chartBlueLevel02 = colorCodeToRGBA("#7AB6FF", 1);
export const chartBlueLevel03 = colorCodeToRGBA("#94C4FF", 1);
export const chartBlueLevel04 = colorCodeToRGBA("#A9D0FF", 1);
export const chartBlueLevel05 = colorCodeToRGBA("#BFDCFF", 1);
export const chartBlueLevel06 = colorCodeToRGBA("#BFDCFF", 1);
export const chartBlueLevel07 = colorCodeToRGBA("#D4E8FF", 1);
